import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';
import { appPath } from 'util/routingConfig';

const routes: CustomRoute = {
	path: appPath.rentalExamination.replace(appPath.rental, ''),
	components: () => [import(/* webpackChunkName: 'rentalExamination' */ './component')],
	render: ([RentalExamination]) => <RentalExamination />,
};

export default routes;
